import React from 'react';

import {SignUp} from 'presentation/pages';

export const MakeSignUp: React.FC = () => <SignUp />;
